import '~/js/modules/slider-with-popup.js';


// scroll to food-trunks
function getFoodTrunks(param) {
    const queryString = window.location.search;
    const URLParams = new URLSearchParams(queryString);
    return URLParams.get(param);
}

function scrollToElement(foodTrucks){
    const targetElement = document.getElementById(foodTrucks);
    if (targetElement) {
        targetElement.scrollIntoView({behavior: 'smooth'});
    }
}

const scrollToValue = getFoodTrunks('scrollTo');
    if (scrollToValue) {
        scrollToElement(scrollToValue);
    }
